// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"_d0b4e3","divider":"_ea4a87ba"};